import React from "react";

import { ReactComponent } from "./chevron-up.svg";

export const ChevronUpIcon = () => {
  return <ReactComponent />;
};
